import * as SearchCriteriasStyle from '../../styles/events/search-criterias.module.scss';
import PropTypes from 'prop-types';
import {concat, filter} from 'lodash';

import Button from '../shared/Button';
import CategoriesContainer from '../shared/CategoriesContainer';
import Encadre from '../shared/ckeditor/Encadre';
import React from 'react';
import Search from '../shared/filter/Search';
import clsx from 'clsx';
import {useTranslation} from 'react-i18next';

const SearchCriterias = React.memo(function SearchCriterias ({
  getSelectedCategories,
  getSearchWordsOnClick,
  locale,
  switchDefault
}) {
  const {t} = useTranslation();
  const [searchWords, setSearchWords] = React.useState('');

  const [category, setCategory] = React.useState([
    {
      id: 'LIVE',
      label: `${t('event.guide.page.live')}`,
      variant: 'color',
      clicked: false,
      lang: locale === 'fr' ? 'en' : '',
    },
  ]);

  const [categories, setCategories] = React.useState([
    {
      id: 'EVENTS_TO_COME',
      label: `${t('event.guide.page.next.events')}`,
      variant: 'color',
      clicked: !switchDefault,
      basecolor: 'var(--red-color)',
      disable: switchDefault
    }, {
      id: 'PAST_EVENTS',
      label: `${t('event.guide.page.past.events')}`,
      variant: 'color',
      clicked: !!switchDefault,
      basecolor: 'var(--red-color)',
    },
  ]);

  const getCategories = React.useCallback((newCategories) => {
    setCategories(newCategories);
  }, []);

  const getCategory = React.useCallback((newCategories) => {
    setCategory(newCategories);
  }, []);

  const getSearchWordsInput = React.useCallback((searchWords) => {
    setSearchWords(searchWords);
    if (searchWords === '') {
      getSearchWordsOnClick('');
    }
  }, [getSearchWordsOnClick]);

  React.useEffect(() => {
    const selectedCategories = filter(categories, (elem) => elem.clicked);
    const selectedCategory = filter(category, (elem) => elem.clicked);
    getSelectedCategories(concat(selectedCategories, selectedCategory));
  }, [categories, category, getSelectedCategories]);

  return (
    <Encadre color="secondary">
      <div className={SearchCriteriasStyle.container}>
        <div className={SearchCriteriasStyle.items}>
          <div style={{marginBottom: 10}}>
            <p className={SearchCriteriasStyle.title}>
              {t('event.guide.page.display')}
            </p>
          </div>
          <div className={SearchCriteriasStyle.divCategorycontainer}>
            {categories?.length > 0 && (
              <CategoriesContainer
                elements={categories}
                getCategories={getCategories}
                isRadio
                isUnique
              />
            )}
            <CategoriesContainer
              elements={category}
              getCategories={getCategory}
              isUnique
            />
          </div>
        </div>
        <div className={SearchCriteriasStyle.itemsbottom}>
          <div style={{marginBottom: 10}}>
            <p className={SearchCriteriasStyle.h6Title}>
              {t('event.guide.page.search')}
            </p>
          </div>
          <div className={SearchCriteriasStyle.divCategorycontainer}>
            <div
              className={clsx(SearchCriteriasStyle.containerItemsSearchBar, SearchCriteriasStyle.rootSmartphone)}
            >
              <Search
                getSearchWords={getSearchWordsInput}
                height={32}
                italic
                padding={8}
                placeholder={t('event.guide.page.short.search')}
              />
            </div>
            <div
              className={clsx(SearchCriteriasStyle.containerItemsSearchBar, SearchCriteriasStyle.rootDesktop)}
            >
              <Search
                getSearchWords={getSearchWordsInput}
                height={15}
                italic
                padding={8}
                placeholder={t('search.bar')}
              />
            </div>
            <div
              className={clsx(SearchCriteriasStyle.containerItemsSearchButton, SearchCriteriasStyle.rootSmartphone)}
            >
              <Button
                onClick={() => getSearchWordsOnClick(searchWords)}
                style={{
                  width: '100%', height: '100%',
                }}
              >
                {t('event.guide.page.short.ok.button')}
              </Button>
            </div>
            <div
              className={clsx(SearchCriteriasStyle.containerItemsSearchButton, SearchCriteriasStyle.rootDesktop)}
            >
              <Button
                onClick={() => getSearchWordsOnClick(searchWords)}
                style={{
                  width: '100%', height: '100%',
                }}
              >
                {t('event.guide.page.ok.button')}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Encadre>
  );
});

SearchCriterias.propTypes = {
  getSearchWordsOnClick: PropTypes.func.isRequired,
  getSelectedCategories: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  switchDefault: PropTypes.bool,
};

export default SearchCriterias;
